/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Box, Flex } from "rebass/styled-components";

import { layout } from "../../../constants/constants";
import { KyruusEmbeddedSearchContent } from "./kyruus-embedded-search-model";
import "./kyruus-embedded-search.scss";
import KyruusInputPlaceholder from "./kyruus-input-placeholder";

export type KyruusEmbeddedSearchProps = {
  content: KyruusEmbeddedSearchContent;
};

const KyruusEmbeddedSearch: React.FC<KyruusEmbeddedSearchProps> = ({ content }: KyruusEmbeddedSearchProps) => {
  const [scriptLoaded, setScriptLoaded] = React.useState(false);
  const widgetHeader = content?.widgetHeader ? React.createElement(content.header_type, {className:'xl-6'}, content?.widgetHeader) : null;
  const hasLocationClass = content?.show_location_field ? "has-location" : "no-location";

  useEffect(() => {
    const kyruusScript = document.createElement("script");
    kyruusScript.src = "https://cdn.kyruus.com/lib/kyruus-search-widget/version/2/kyruus-search-widget.min.js";
    kyruusScript.async = true;
    kyruusScript.onload = () => {
      setScriptLoaded(true);
    };

    document.body.appendChild(kyruusScript);

    return () => {
      document.body.removeChild(kyruusScript);
    };
  }, [setScriptLoaded]);

  useEffect(() => {
    if (scriptLoaded) {
      const kyruusSearchWidget = new KyruusSearchWidget({
        pm_url: content?.kyruus_provider_match_url,
        search_label: content?.search_label,
        location_label: content?.location_label,
        message: content?.search_box_placeholder_text,
        customer_code: content?.customer_code,
        typeahead_categories: content?.typeahead_categories,
        pre_filters: content?.pre_filters,
        environment: "production",
        show_location: content?.show_location_field,
        location_message: content?.location_box_placeholder_message,
        location_search_radius: content?.location_search_radius,
        persist_query: "true",
        allow_empty_search: true,
        focus_on_widget: false,
        use_primary_care_condition: false,
        el: document.getElementById(`${content?.dom_element_id}`),
        sort_order: content?.sort_order
      });
    }
  }, [scriptLoaded]);

  return (
    <>
      <Helmet>
        <link rel="stylesheet" href="https://cdn.kyruus.com/pmc-customer-static-assets/corewell/custom-style/1.3/corewell-custom.css" />
      </Helmet>
      <Box className="kyruus-widget-container">
        <Flex className={`kyruus-search-widget ${hasLocationClass}`} width={layout?.pageWidth} px={layout.pagePaddingX} marginX={"auto"}>
          {widgetHeader}
          {content?.subheader && <p className="large-text">{content?.subheader}</p>}
          {!scriptLoaded && <KyruusInputPlaceholder content={content} />}
          {scriptLoaded && <div className="kyruus-div" id={content.dom_element_id}></div>}
        </Flex>
      </Box>
    </>
  );
};

export default KyruusEmbeddedSearch;
